import React, { Component } from 'react';
import { createStore, type Store } from 'redux';
import { type PersistPartial, persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage';
import { createWhitelist } from '@atlassian/jira-portfolio-3-common/src/redux';
import { createProvider } from '@atlassian/jira-react-redux';
import type { Action } from './actions';
import { Provider as ColumnTextsProvider } from './column-texts';

import { SectionContext } from './context';
import reducer from './reducer';

import type { State, ProviderProps } from './types';
import { storeKey } from './util';

const sectionsWhitelist = createWhitelist(['sections'], {
	'*': {
		totalWidth: true,
		widths: true,
		minWidths: true,
		activeSeparatorIndex: false,
		hoveredSectionIndex: false,
		preDragWidths: true,
	},
});

const persistedReducer = persistReducer(
	{
		key: storeKey,
		storage,
		whitelist: ['sections'],
		transforms: [sectionsWhitelist],
	},
	reducer,
);

const store = createStore<State & PersistPartial, Action, unknown, unknown>(persistedReducer);
const persistor = persistStore(store);

export const Provider = createProvider(SectionContext, storeKey);

// eslint-disable-next-line jira/react/no-class-components
export default class SectionsProvider extends Component<ProviderProps, { store: Store<State> }> {
	state = {
		store,
	};

	render() {
		return (
			<ColumnTextsProvider>
				<Provider store={this.state.store}>
					<PersistGate loading={null} persistor={persistor}>
						{this.props.children}
					</PersistGate>
				</Provider>
			</ColumnTextsProvider>
		);
	}
}
